import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import WhyMatters from "@/components/WhyMatters";
import HowItWorks from "@/components/HowItWorks";
import WhoWeServe from "@/components/WhoWeServe";
import Security from "@/components/Security";
import CtaBand from "@/components/CtaBand";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Services />
      <WhyMatters />
      <HowItWorks />
      <WhoWeServe />
      <Security />
      <CtaBand />
      <Contact />
      <Footer />
    </main>
  );
}
